module.exports = __webpack_public_path__ + "img/ic24ViewOffRed.755043ed.svg";